import type {
  CreateRbacRoleFamilyRequest,
  RbacRoleFamily,
  UpdateRbacRoleFamilyRequest,
} from '@gozoki/api-types'
import { mutationOptions } from '@tanstack/react-query'
import { gozokiApiWithAuth } from '../gozokiApi'
import { keys } from '../queries/keys'

/**
 * Écritures des familles de rôles (spec §5, §8.2). Une famille ne confère aucun droit : ces trois
 * appels sont gardés comme la modification d'un rôle (`edit roles-admin.roles.role`) et ne touchent
 * jamais une permission.
 */

export const createRbacRoleFamily = async (data: CreateRbacRoleFamilyRequest) => {
  const response = await gozokiApiWithAuth.post<RbacRoleFamily>('/rbac/families', data)
  return response.data
}

export const updateRbacRoleFamily = async ({
  key,
  data,
}: {
  key: string
  data: UpdateRbacRoleFamilyRequest
}) => {
  const response = await gozokiApiWithAuth.patch<RbacRoleFamily>(`/rbac/families/${key}`, data)
  return response.data
}

export const deleteRbacRoleFamily = async (key: string) => {
  const response = await gozokiApiWithAuth.delete<{ deleted: string; releasedRoles: number }>(
    `/rbac/families/${key}`,
  )
  return response.data
}

export const createRbacRoleFamilyOptions = () =>
  mutationOptions({
    mutationFn: createRbacRoleFamily,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

export const updateRbacRoleFamilyOptions = () =>
  mutationOptions({
    mutationFn: updateRbacRoleFamily,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

export const deleteRbacRoleFamilyOptions = () =>
  mutationOptions({
    mutationFn: deleteRbacRoleFamily,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })
